export default [
    {
        path: 'sysHotelCheck',
        name: 'sysHotelCheck',
        component: resolve=>(require(["../views/hotelCheck/sysHotelCheck/sysHotelCheck"],resolve))
    },
    {
        path: 'sysHotelCheckHistory',
        name: 'sysHotelCheckHistory',
        component: resolve=>(require(["../views/hotelCheck/sysHotelCheckHistory/sysHotelCheckHistory"],resolve))
    },
    {
        path: 'sysAgreement',
        name: 'sysAgreement',
        component: resolve=>(require(["../views/hotelCheck/sysAgreement/sysAgreement"],resolve))
    },
    {
        path: 'sysShopManage',
        name: 'sysShopManage',
        component: resolve=>(require(["../views/hotelCheck/sysShopManage/sysShopManage"],resolve))
    },
    {
        path: 'sysHotel',
        name: 'sysHotel',
        component: resolve=>(require(["../views/hotelCheck/sysHotel/sysHotel"],resolve))
    },
    {
        path: 'sysHotelAdmin',
        name: 'sysHotelAdmin',
        component: resolve=>(require(["../views/hotelCheck/sysHotelAdmin/sysHotel"],resolve))
    },
    {
        path: 'sysCheck',
        name: 'sysCheck',
        component: resolve=>(require(["../views/hotelCheck/sysCheck/sysCheck"],resolve))
    },
    {
        path: 'sysCheckHistory',
        name: 'sysCheckHistory',
        component: resolve=>(require(["../views/hotelCheck/sysCheckHistory/sysCheckHistory"],resolve))
    },

]
